const styles = {
  loader: {
    zIndex: (theme) => theme.zIndex.modal + 1,
    color: 'primary.white',
    backdropFilter: 'blur(2px)',
    transition: 'opacity 0.3s ease-in-out',
  },
};

export default styles;
